module.exports = __webpack_public_path__ + "static/assets/43feef51a5358b1f86b7cf5a71d44ace.svg";